import React from 'react'
import FeatureDetail from './FeatureDetail'
import { featuresDescription } from '../constants'
import { FormattedMessage } from 'react-intl'

const FeaturesSection = () => {
  return (
    <div className="mv4 pv4 bg-lighter-gray">
      <div className="items-center">
        <div className="mb3 mt4-ns tc f4 b f2-ns default-color">
          <FormattedMessage id="features.title" />
        </div>
        <div className="mb3 mb5-ns mt3 tc f5 f4-ns default-color">
          <FormattedMessage id="features.caption" />
        </div>
      </div>
      <div className="flex flex-row-ns flex-column">
        <div className="flex flex-column order-1 order-0-ns justify-around w-33-ns w-100 ph4">
          {
            featuresDescription
              .filter(feature => feature.textAlignment === 'right')
              .map(feature => {
                return (
                  <div
                    key={feature.title}
                    className="ma3 ma0-ns">
                    <FeatureDetail
                      title={feature.title}
                      content={feature.content}
                      alignment="tr-ns tc"
                    />
                  </div>
                )
              })
          }
        </div>

        <div className="flex flex-column order-0-s order-2-ns justify-around w-33-ns w-100 ph4">
          <div className="mb3">
            <img
              src="images/insights-metric-example.png"
              alt="usage example"
              className="img center"
            />
          </div>
        </div>

        <div className="flex flex-column order-2 order-2-ns justify-around w-33-ns w-100 ph4">
          {
            featuresDescription
              .filter(feature => feature.textAlignment === 'left')
              .map(feature => {
                return (
                  <div
                    key={feature.title}
                    className="ma3 ma0-ns">
                    <FeatureDetail
                      key={feature.title}
                      title={feature.title}
                      content={feature.content}
                      alignment="tl-ns tc"
                    />
                  </div>
                )
              })
          }
        </div>
      </div>
    </div>
  )
}

export default FeaturesSection



// WEBPACK FOOTER //
// ./src/components/FeaturesSection.js